import React from 'react';
export const AssignHeader = () => {
  return (
    <>
      <span style={{ fontWeight: 500 }}>{'Assign'}</span>
    </>
  );
};
